module.exports = __webpack_public_path__ + "img/thumb_Atelier_5.b633e62e.jpg";